import * as t from "./types";
import * as actions from "./action";

/* External Link */
export const getExternalLinkAction = (
  payload: t.GetExternalLinkRequestType
): t.GetExternalLinkActionType => {
  return {
    type: actions.GET_EXTERNAL_LINK,
    payload,
  };
};

export const getExternalLinksAction = (
  payload: t.GetExternalLinksRequestType
): t.GetExternalLinksActionType => {
  return {
    type: actions.GET_EXTERNAL_LINKS,
    payload,
  };
};

export const addExternalLinkAction = (
  payload: t.CreateExternalLinkRequestType
): t.AddExternalLinkActionType => {
  return {
    type: actions.ADD_EXTERNAL_LINK,
    payload,
  };
};

export const modifyExternalLinkAction = (
  payload: t.ModifyExternalLinkRequestType
): t.ModifyExternalLinkActionType => {
  return {
    type: actions.MODIFY_EXTERNAL_LINK,
    payload,
  };
};

export const deleteExternalLinkAction = (
  payload: t.DeleteExternalLinkRequestType
): t.DeleteExternalLinkActionType => {
  return {
    type: actions.DELETE_EXTERNAL_LINK,
    payload,
  };
};
